import httpClient from 'api/httpClient';
import { InventoryPlacement } from 'models/InventoryPlacement';
import {
  Pagination,
  RequestParams,
} from 'router/subrouters/Dashboard/pages/hooks/usePaginatedItems';

const getInventoryPlacement = (params: RequestParams<any>) =>
  httpClient
    .get<Pagination<InventoryPlacement>>('/inventory-placement', { params })
    .then(({ data }) => data);

const addInventoryPlacement = (
  skuNo: string,
  quantity: number,
  binNo: number,
  storeNo: number,
) =>
  httpClient.patch(`admin-products/${skuNo}/inventory/edit`, {
    quantity,
    binNo,
    storeNo,
  });

export default {
  getInventoryPlacement,
  addInventoryPlacement,
};
